// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1CHjK","title":"Images90_title__1rQ7b","images":"Images90_images__2s2qw"};